
import { filter } from "rxjs/operators";
import { EmailHistory, EmailHistoriesDocument } from "src/generated-gql/graphql";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import {
  SharedModule,
  TypedBaseListComponent,
  ModalService,
} from "@bb-vendure/admin-ui/core";

@Component({
  selector: "alert-list",
  templateUrl: "./list.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule],
})
export default class EmailHistoryListComponent extends TypedBaseListComponent<
  typeof EmailHistoriesDocument,
  "emailHistories"
> {
  constructor(private modalService: ModalService) {
    super();
    super.configure({
      document: EmailHistoriesDocument,
      getItems: (data) => data.emailHistories,
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: this.filters.createFilterInput(),
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    // .addFilters([
    // ])
    .connectToRoute(this.route);
    
  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSorts([
      { name: "id" },
      { name: "code" },
      { name: "createdAt" },
      { name: "updatedAt" },
    ]);
}
